import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Custom(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Custom", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12.0588 24.3777h6.6668c.347-.0011.6908.0664 1.0116.1987.3208.1323.6123.3268.8577.5721.2454.2454.4398.5369.5721.8577.1323.3208.1998.6646.1987 1.0116v13.3419c.0011.347-.0664.6908-.1987 1.0116-.1323.3208-.3267.6123-.5721.8577-.2454.2454-.5369.4398-.8577.5721-.3208.1323-.6646.1998-1.0116.1987h-6.6668V24.3777Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M5.38283 24.3777h6.67507v18.6221H5.37453c-.34702.0011-.69082-.0664-1.01163-.1987-.32082-.1323-.6123-.3267-.85768-.5721-.24538-.2454-.4398-.5369-.5721-.8577-.13229-.3208-.19983-.6646-.19873-1.0116V27.0178c-.0011-.347.06644-.6908.19873-1.0116.1323-.3208.32672-.6123.5721-.8577.24538-.2453.53686-.4398.85768-.5721.32081-.1323.66461-.1998 1.01163-.1987h.0083Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.9434 24.3775h6.6667c.3471-.0011.6909.0664 1.0117.1987.3208.1323.6123.3267.8576.5721.2454.2454.4399.5369.5721.8577.1323.3208.1999.6646.1988 1.0116v13.3418c.0011.3471-.0665.6909-.1988 1.0117-.1322.3208-.3267.6123-.5721.8577-.2453.2453-.5368.4398-.8576.5721-.3208.1322-.6646.1998-1.0117.1987h-6.6667V24.3775Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M29.268 24.3777h6.6751v18.6221H29.268c-.347.0011-.6908-.0664-1.0117-.1987-.3208-.1323-.6123-.3267-.8576-.5721-.2454-.2454-.4398-.5369-.5721-.8577-.1323-.3208-.1999-.6646-.1988-1.0116V27.0178c-.0011-.347.0665-.6908.1988-1.0116.1323-.3208.3267-.6123.5721-.8577.2453-.2453.5368-.4398.8576-.5721.3209-.1323.6647-.1998 1.0117-.1987Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M24.3057 5.00001h6.675c.3471-.00109.6909.06645 1.0117.19874.3208.13229.6123.32672.8576.5721.2454.24538.4399.53686.5721.85767.1323.32081.1999.66462.1988 1.01164V20.982c.0011.347-.0665.6908-.1988 1.0116-.1322.3209-.3267.6123-.5721.8577-.2453.2454-.5368.4398-.8576.5721-.3208.1323-.6646.1998-1.0117.1988H24.314l-.0083-18.62219Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17.6402 5.00001h6.6667V23.6222h-6.6667c-.3471.001-.6909-.0665-1.0117-.1988-.3208-.1323-.6123-.3267-.8577-.5721-.2453-.2454-.4398-.5368-.5721-.8577-.1322-.3208-.1998-.6646-.1987-1.0116V7.64016c-.0011-.34702.0665-.69083.1987-1.01164.1323-.32081.3268-.61229.5721-.85767.2454-.24538.5369-.43981.8577-.5721.3208-.13229.6646-.19983 1.0117-.19874Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M22.7232 14.5543h3.1964l-.988-2.607c-.2476-.6439-.4692-1.2975-.6642-1.95932-.1217.61282-.291 1.21512-.5064 1.80162l-1.0378 2.7647Zm-2.7149 3.8688L23.6281 9h1.3367l3.8606 9.4231h-1.4197l-1.1042-2.856h-3.9353l-1.0378 2.856H20h.0083Zm-9.7629 18.891h2.3412c.2831.0048.5662-.0119.8468-.0498.2543-.0368.4994-.1213.7224-.249.202-.1321.3653-.3155.4732-.5314.1279-.2431.1935-.5141.1909-.7887.0051-.3254-.0906-.6444-.2739-.9133-.1813-.2606-.4442-.4534-.7473-.5479-.4486-.1232-.9131-.1791-1.3781-.1661h-2.1752v3.2462Zm0-4.3504h2.034c.3988.016.7979-.0203 1.1873-.1079.2842-.0734.5356-.2401.714-.4733.1717-.2388.2593-.5279.249-.8219.0068-.2925-.071-.5808-.2241-.8302-.1504-.2338-.3805-.4049-.6476-.4816-.4707-.1085-.9538-.1532-1.4363-.1328h-1.8763v2.8477ZM9 38.4266v-9.4231h3.5285c.5915-.0236 1.1817.0724 1.7352.2823.4247.1824.7817.493 1.0212.8883.2375.372.3642.804.3653 1.2454-.0022.4001-.1173.7915-.3321 1.1291-.2381.3749-.5779.6744-.9797.8634.5135.1183.9706.4099 1.2942.8258.3236.4158.494.9305.4825 1.4574.0002.4016-.0874.7985-.2566 1.1627-.1692.3643-.416.6872-.7231.9461-.3091.2214-.659.3794-1.0295.4649-.498.1146-1.0083.1675-1.5193.1577H9Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m40.3251 35.6004-1.2454-.3155c-.1165.6925-.4648 1.3249-.988 1.7934-.498.4069-1.1254.6219-1.7684.606-.5728 0-1.1125-.1494-1.6106-.4483-.5-.3113-.8803-.7823-1.0793-1.3367-.2325-.606-.3487-1.2951-.3487-2.1005-.0031-.6151.095-1.2266.2906-1.8099.1831-.5641.5444-1.0535 1.0295-1.3948.5319-.3633 1.1662-.5466 1.8099-.523.5611-.0212 1.1133.1453 1.5691.4732.4662.3865.8.909.9548 1.4944l1.2204-.2905c-.2077-.8052-.6781-1.5181-1.3367-2.0258-.6392-.4732-1.4363-.7223-2.3827-.7223-.7983-.0048-1.5844.1953-2.2832.5811-.6912.3768-1.2504.9563-1.6023 1.6605-.3553.7998-.5437 1.6636-.5537 2.5387-.01.8751.1586 1.743.4956 2.5506.291.7314.7978 1.3569 1.4529 1.7933.747.4428 1.6065.6591 2.4741.6227.8983.0271 1.7783-.2575 2.4907-.8053.7173-.6021 1.2139-1.4258 1.4114-2.3413Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Custom.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Custom"
};
validateTidalLicense();
export {
  Custom
};
//# sourceMappingURL=Custom.js.map
